import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//bts
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle'
// ele UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//umy-ui
import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css'
//echarts
// import charts from 'echarts'
// Vue.prototype.$echarts = charts

Vue.use(ElementUI)
Vue.use(UmyUi)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
